export const routes = [
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/account-center',
    /* internal name: '/account-center' */
    /* no component */
    children: [
      {
        path: '',
        name: 'AccountCenter',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/account-center/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "account-center-index.title"
        },
      }
    ],
  },
  {
    path: '/activity',
    /* internal name: '/activity' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Activity',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/activity/details' */
        /* no component */
        children: [
          {
            path: 'acti-info',
            name: 'acti-info',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info.vue'),
            /* no children */
          },
          {
            path: 'acti-info-baoxiang-copy',
            name: '/activity/details/acti-info-baoxiang-copy',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info-baoxiang-copy.vue'),
            /* no children */
          },
          {
            path: 'acti-info-five',
            name: '/activity/details/acti-info-five',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info-five.vue'),
            /* no children */
          },
          {
            path: 'acti-info-four',
            name: 'acti-info-four',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info-four.vue'),
            /* no children */
          },
          {
            path: 'acti-info-six',
            name: '/activity/details/acti-info-six',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info-six.vue'),
            /* no children */
          },
          {
            path: 'acti-info-two',
            name: 'acti-info-two',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/acti-info-two.vue'),
            /* no children */
          },
          {
            path: 'Bonus-de-novo-jogador',
            name: 'Bonus-de-novo-jogador',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/Bonus-de-novo-jogador.vue'),
            /* no children */
          },
          {
            path: 'subs',
            /* internal name: '/activity/details/subs' */
            /* no component */
            children: [
              {
                path: 'meus-sub',
                name: 'meus-sub',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/subs/meus-sub.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'taxt-de-info',
            name: 'taxt-de-info',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/details/taxt-de-info.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'lottery',
        /* internal name: '/activity/lottery' */
        /* no component */
        children: [
          {
            path: 'blind-boxes',
            /* internal name: '/activity/lottery/blind-boxes' */
            /* no component */
            children: [
              {
                path: 'iPhone17',
                name: 'Lottery-BlindBoxes-iPhone17',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/lottery/blind-boxes/iPhone17.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'roleta',
        /* internal name: '/activity/roleta' */
        /* no component */
        children: [
          {
            path: '',
            name: 'Roleta',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/activity/roleta/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/agent',
    /* internal name: '/agent' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Agent',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/agent/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/betting-history',
    /* internal name: '/betting-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'BettingHistory',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/betting-history/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "betting-history-index.title"
        },
      }
    ],
  },
  {
    path: '/carteira',
    /* internal name: '/carteira' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Carteira',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/carteira/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/change-password',
    /* internal name: '/change-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ChangePassword',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/change-password/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "change-password-index.title"
        },
      }
    ],
  },
  {
    path: '/charts',
    /* internal name: '/charts' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Charts',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/charts/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/check-in',
    /* internal name: '/check-in' */
    /* no component */
    children: [
      {
        path: '',
        name: 'CheckIn',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/check-in/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/counter',
    /* internal name: '/counter' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Counter',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/counter/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/deposit-history',
    /* internal name: '/deposit-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'DepositHistory',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/deposit-history/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/deposito',
    /* internal name: '/deposito' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Deposito',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/deposito/index.vue'),
        /* no children */
      },
      {
        path: 'template',
        /* internal name: '/deposito/template' */
        /* no component */
        children: [
          {
            path: 'index_50000',
            name: '/deposito/template/index_50000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/deposito/template/index_50000.vue'),
            /* no children */
          },
          {
            path: 'index_52000',
            name: '/deposito/template/index_52000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/deposito/template/index_52000.vue'),
            /* no children */
          },
          {
            path: 'index_53000',
            name: '/deposito/template/index_53000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/deposito/template/index_53000.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/depositoPayIframe',
    /* internal name: '/depositoPayIframe' */
    /* no component */
    children: [
      {
        path: 'depositoPayIframe',
        name: 'DepositoPayIframe',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/depositoPayIframe/depositoPayIframe.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dispositivo',
    /* internal name: '/dispositivo' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Dispositivo',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/dispositivo/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "dispositivo-index.title"
        },
      }
    ],
  },
  {
    path: '/forgot-password',
    /* internal name: '/forgot-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ForgotPassword',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/forgot-password/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/games',
    /* internal name: '/games' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Games',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/games/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/home/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/keepalive',
    /* internal name: '/keepalive' */
    /* no component */
    children: [
      {
        path: '',
        name: 'KeepAlive',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/keepalive/index.vue'),
        /* no children */
        meta: {
          "keepAlive": true
        },
      }
    ],
  },
  {
    path: '/land',
    /* internal name: '/land' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Land',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/land/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/mail',
    /* internal name: '/mail' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Mail',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/mail/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/messages',
    /* internal name: '/messages' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Messages',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/messages/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "messages-index.index.title"
        },
      },
      {
        path: 'details',
        /* internal name: '/messages/details' */
        /* no component */
        children: [
          {
            path: 'Details',
            name: 'MessageDetails',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/messages/details/Details.vue'),
            /* no children */
            meta: {
              "i18nTitleKey": "messages-index.index.detailsTitle"
            },
          }
        ],
      }
    ],
  },
  {
    path: '/nickname',
    /* internal name: '/nickname' */
    /* no component */
    children: [
      {
        path: '',
        name: 'nickname',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/nickname/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Profile',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "profile-index.routes.profile"
        },
      },
      {
        path: 'seguranca',
        /* internal name: '/profile/seguranca' */
        /* no component */
        children: [
          {
            path: '',
            name: 'Seguranca',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/index.vue'),
            /* no children */
            meta: {
              "i18nTitleKey": "profile-index.routes.security"
            },
          },
          {
            path: 'details',
            /* internal name: '/profile/seguranca/details' */
            /* no component */
            children: [
              {
                path: 'EMail',
                name: 'EMail',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/EMail.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.email"
                },
              },
              {
                path: 'Google',
                name: 'Google',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/Google.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.google"
                },
              },
              {
                path: 'Pergunta',
                name: 'Pergunta',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/Pergunta.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.securityQuestion"
                },
              },
              {
                path: 'SenhaLogin',
                name: 'SenhaLogin',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/SenhaLogin.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.loginPassword"
                },
              },
              {
                path: 'SenhaSaque',
                name: 'SenhaSaque',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/SenhaSaque.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.withdrawalPassword"
                },
              },
              {
                path: 'Telefone',
                name: 'Telefone',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/seguranca/details/Telefone.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.phone"
                },
              }
            ],
          }
        ],
      },
      {
        path: 'template',
        /* internal name: '/profile/template' */
        /* no component */
        children: [
          {
            path: 'index_50000',
            name: '/profile/template/index_50000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/template/index_50000.vue'),
            /* no children */
          },
          {
            path: 'index_52000',
            name: '/profile/template/index_52000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/template/index_52000.vue'),
            /* no children */
          },
          {
            path: 'index_53000',
            name: '/profile/template/index_53000',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/template/index_53000.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user-info',
        /* internal name: '/profile/user-info' */
        /* no component */
        children: [
          {
            path: '',
            name: 'UserInfo',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/user-info/index.vue'),
            /* no children */
            meta: {
              "i18nTitleKey": "profile-index.routes.userInfo"
            },
          },
          {
            path: 'avatar',
            /* internal name: '/profile/user-info/avatar' */
            /* no component */
            children: [
              {
                path: '',
                name: 'Avatar',
                component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/profile/user-info/avatar/index.vue'),
                /* no children */
                meta: {
                  "i18nTitleKey": "profile-index.routes.avatar"
                },
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/promocao',
    /* internal name: '/promocao' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Promocao',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/promocao/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "promocao-index.index.title"
        },
      }
    ],
  },
  {
    path: '/recuperar',
    /* internal name: '/recuperar' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recuperar/',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/recuperar/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Registros',
    /* internal name: '/Registros' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Registros',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Registros/index.vue'),
        /* no children */
      },
      {
        path: 'ContaDetails',
        /* internal name: '/Registros/ContaDetails' */
        /* no component */
        children: [
          {
            path: 'ContaDetails',
            name: 'ContaDetails',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Registros/ContaDetails/ContaDetails.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/Saque',
    /* internal name: '/Saque' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Saque',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Saque/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/Saque/details' */
        /* no component */
        children: [
          {
            path: 'saquesDetails',
            name: 'SaquesDetails',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Saque/details/saquesDetails.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'SaquesApostasDetalhes',
        name: 'SaquesApostasDetalhes',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Saque/SaquesApostasDetalhes.vue'),
        /* no children */
      },
      {
        path: 'SaquesTarefas',
        name: 'SaquesTarefas',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/Saque/SaquesTarefas.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/SaqueSetting',
    /* internal name: '/SaqueSetting' */
    /* no component */
    children: [
      {
        path: '',
        name: 'SaqueSetting',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/SaqueSetting/index.vue'),
        /* no children */
        meta: {
          "i18nTitleKey": "saqueSetting-index.title"
        },
      }
    ],
  },
  {
    path: '/scroll-cache',
    /* internal name: '/scroll-cache' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ScrollCache',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/scroll-cache/index.vue'),
        /* no children */
        meta: {
          "keepAlive": true
        },
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/settings/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test',
    /* internal name: '/test' */
    /* no component */
    children: [
      {
        path: '',
        name: 'test',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/test/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/transaction-password',
    /* internal name: '/transaction-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'TransactionPassword',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/transaction-password/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/unocss',
    /* internal name: '/unocss' */
    /* no component */
    children: [
      {
        path: '',
        name: 'UnoCSS',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/unocss/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/vendorearch',
    /* internal name: '/vendorearch' */
    /* no component */
    children: [
      {
        path: '',
        name: 'vendorearch',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/vendorearch/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/vendorearch/details' */
        /* no component */
        children: [
          {
            path: 'testsearch',
            name: 'testsearch',
            component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/vendorearch/details/testsearch.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/withdrawal-history',
    /* internal name: '/withdrawal-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'WithdrawalHistory',
        component: () => import('C:/Users/Administrator/Desktop/newcode/e_frontend_win1/frontend_win1/src/pages/withdrawal-history/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

